import { render, staticRenderFns } from "./checkCN.vue?vue&type=template&id=74f48334&scoped=true&"
import script from "./checkCN.vue?vue&type=script&lang=js&"
export * from "./checkCN.vue?vue&type=script&lang=js&"
import style0 from "./checkCN.vue?vue&type=style&index=0&id=74f48334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f48334",
  null
  
)

export default component.exports